import React, { useState } from 'react';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import { request, useOperations } from './OperationsProvider';

// Taking a truck off the register.
//
// Two different things wear the same button, and the dialog says which one it is about to do before
// it does it: a truck that has never run is a mistake - a mistyped plate, a spreadsheet loaded by
// accident - and goes; a truck that has hauled something is history, and is retired instead, because
// its trips name it and a trip that names nothing is worse than an old truck on the register.
export default function RemoveVehicle({ vehicle, trips = [], onClose }) {
  const { refresh } = useOperations();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const hauled = trips.filter((trip) => trip.vehicleId === vehicle.id).length;

  const remove = async () => {
    setPending(true); setError('');
    try {
      await request(`/api/operations/vehicles/${vehicle.id}`, 'DELETE');
      await refresh();
      onClose();
    } catch (e) { setError(e.message); } finally { setPending(false); }
  };

  return (
    <Dialog open onClose={() => !pending && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>{hauled ? `Retire ${vehicle.name}?` : `Remove ${vehicle.name}?`}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {hauled
            ? `${vehicle.name} has run ${hauled} ${hauled === 1 ? 'trip' : 'trips'}, so it is retired rather than erased: those trips keep naming it, and it stops being offered at the desks.`
            : `${vehicle.name} has never run a trip, so it is removed from the register entirely.`}
        </Typography>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button disabled={pending} onClick={onClose}>Cancel</Button>
        <Button color="error" variant="contained" disabled={pending} onClick={remove}>{pending ? 'Working…' : hauled ? 'Retire' : 'Remove'}</Button>
      </DialogActions>
    </Dialog>
  );
}
